module.exports = __webpack_public_path__ + "assets/img/20.44f870d2.png";